import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GeometryFilters } from '@/context/geometry';
import {
  filtersToQueryParams,
  parseFiltersFromSearchParams,
} from '@/utils/functions/advancedFilters';

export const useAdvancedFiltersUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getFiltersFromUrl = useCallback((): GeometryFilters => {
    const params = new URLSearchParams(location.search);
    return parseFiltersFromSearchParams(params);
  }, [location.search]);

  const setFiltersToUrl = useCallback(
    (path: string, filters: GeometryFilters) => {
      const query = filtersToQueryParams(filters);
      navigate(`${path}?${query}`, { replace: false });
    },
    [navigate]
  );

  return { getFiltersFromUrl, setFiltersToUrl };
};
